import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DynamicTable from "../../../../unicomponents/Tables/DynamicTable";
import useCertificateHistory from "../../../../hooks/useCertificateHistory";
import { useLocation } from "react-router-dom";
import CertificateInfoModal from "./CertificateInfoModal";

export default function CertificateManagement() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];

  const [rows, setRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const {
    certificateHistoryQuery: { data: certificateHistoryData },
  } = useCertificateHistory({ schoolid: schoolId });

  useEffect(() => {
    if (certificateHistoryData) {
      console.log("certificateHistoryQuery.data", certificateHistoryData);
      setRows(certificateHistoryData);
    }
  }, [certificateHistoryData]);

  //자 이제 백엔드 만들어서 데이터 불러오면 된다.

  // 더미 데이터
  // const rows = [
  //   {
  //     certificate_no: "CERT-2024-001",
  //     certificate_date: "2024-01-15",
  //     certificate_type: "재학증명서",
  //     subject_name: "김민수",
  //     subject_username: "student001",
  //     issuer_name: "홍길동",
  //     issuer_username: "teacher001",
  //     request_date: "2024-01-14",
  //     purpose: "취업",
  //     status: "발급완료",
  //   },
  //   {
  //     certificate_no: "CERT-2024-002",
  //     certificate_date: "2024-01-16",
  //     certificate_type: "성적증명서",
  //     subject_name: "이영희",
  //     subject_username: "student002",
  //     issuer_name: "박선생",
  //     issuer_username: "teacher002",
  //     request_date: "2024-01-15",
  //     purpose: "진학",
  //     status: "발급완료",
  //   },
  //   {
  //     certificate_no: "CERT-2024-003",
  //     certificate_date: "2024-01-17",
  //     certificate_type: "졸업증명서",
  //     subject_name: "최철수",
  //     subject_username: "student003",
  //     issuer_name: "김교사",
  //     issuer_username: "teacher003",
  //     request_date: "2024-01-16",
  //     purpose: "취업",
  //     status: "발급대기",
  //   },
  //   {
  //     certificate_no: "CERT-2024-004",
  //     certificate_date: "2024-01-18",
  //     certificate_type: "수료증명서",
  //     subject_name: "정미영",
  //     subject_username: "student004",
  //     issuer_name: "이담임",
  //     issuer_username: "teacher004",
  //     request_date: "2024-01-17",
  //     purpose: "자격증 취득",
  //     status: "발급완료",
  //   },
  //   {
  //     certificate_no: "CERT-2024-005",
  //     certificate_date: "",
  //     certificate_type: "재학증명서",
  //     subject_name: "장준호",
  //     subject_username: "student005",
  //     issuer_name: "",
  //     issuer_username: "",
  //     request_date: "2024-01-18",
  //     purpose: "병역",
  //     status: "승인대기",
  //   },
  //   {
  //     certificate_no: "CERT-2024-006",
  //     certificate_date: "2024-01-19",
  //     certificate_type: "성적증명서",
  //     subject_name: "윤서연",
  //     subject_username: "student006",
  //     issuer_name: "최교무",
  //     issuer_username: "teacher005",
  //     request_date: "2024-01-18",
  //     purpose: "장학금 신청",
  //     status: "발급완료",
  //   },
  //   {
  //     certificate_no: "CERT-2024-007",
  //     certificate_date: "",
  //     certificate_type: "출석증명서",
  //     subject_name: "강동현",
  //     subject_username: "student007",
  //     issuer_name: "",
  //     issuer_username: "",
  //     request_date: "2024-01-19",
  //     purpose: "보험청구",
  //     status: "반려",
  //   },
  //   {
  //     certificate_no: "CERT-2024-008",
  //     certificate_date: "2024-01-20",
  //     certificate_type: "졸업증명서",
  //     subject_name: "송하늘",
  //     subject_username: "student008",
  //     issuer_name: "안행정",
  //     issuer_username: "admin001",
  //     request_date: "2024-01-19",
  //     purpose: "해외진학",
  //     status: "발급완료",
  //   },
  // ];

  const certificateTypeMap = {
    employmentCertificate: t("admin.certificate.employment") || "재직증명서",
    enrollmentCertificate: t("admin.certificate.enrollment") || "재학증명서",
    admissionCertificate: t("admin.certificate.admission") || "입학증명서",
    expectedGraduationCertificate:
      t("admin.certificate.expectedGraduation") || "졸업예정증명서",
    graduationCertificate: t("admin.certificate.graduation") || "졸업증명서",
  };

  const statusMap = {
    pending: t("admin.certificate.pending") || "대기",
    completed: t("admin.certificate.completed") || "완료",
  };

  const viewCertificateInfo = (item) => {
    console.log("item", item);
    setSelectedCertificate(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCertificate(null);
  };

  // 테이블 설정
  const tableConfig = {
    style: { fontSize: "14px" }, // 폰트 크기만 커스텀
    headers: [
      {
        label: t("admin.certificate.certificateNo") || "발급번호",
        sortField: "certificate_no",
      },
      {
        label: t("admin.certificate.issueDate") || "발급일",
        sortField: "issue_date",
      },
      {
        label: t("admin.certificate.certificateType") || "증명서 유형",
        sortField: "certificate_type",
      },
      {
        label: t("admin.certificate.subject") || "대상자",
        sortField: "subjectUser.fullname",
      },
      {
        label: t("admin.certificate.subjectId") || "대상자 아이디",
      },
      {
        label: t("admin.certificate.issuer") || "발급자",
        sortField: "issuerUser.fullname",
      },
      {
        label: t("admin.certificate.issuerId") || "발급자 아이디",
      },
      {
        label: t("admin.certificate.requestDate") || "요청일",
        sortField: "request_date",
      },
      {
        label: t("admin.certificate.purpose") || "용도",
        sortField: "purpose",
      },
      {
        label: t("admin.certificate.status") || "상태",
        sortField: "status",
      },
      {
        label: t("admin.certificate.viewInfo") || "발급정보열람",
      },
    ],
    columns: [
      {
        valueKey: "certificate_no",
      },
      {
        valueKey: "issue_date",
      },
      {
        valueKey: "certificate_type",
        valueFormatter: (value) => {
          return certificateTypeMap[value] || value;
        },
      },
      {
        valueKey: "subjectUser.fullname",
      },
      {
        valueKey: "subject_username",
      },
      {
        valueKey: "issuerUser.fullname",
      },
      {
        valueKey: "issuer",
      },
      {
        valueKey: "request_date",
      },
      {
        valueKey: "purpose",
      },
      {
        valueKey: "status",
        valueFormatter: (value) => {
          return statusMap[value] || value;
        },
      },
      {
        valueKey: "actions",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value, item) => (
          <div className="d-flex gap-1 ms-1 text-center justify-content-center">
            <button
              className={"btn ps-1 pe-1 m-0 btn-sm btn-primary"}
              onClick={() => {
                viewCertificateInfo(item);
              }}
            >
              {t("admin.certificate.view") || "보기"}
            </button>
          </div>
        ),
      },
    ],
    rows: rows.map((row) => ({
      ...row,
      actions: "buttons", // 버튼 컬럼용 더미 값
    })),
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col-auto">
          <h3 className="fw-bold">
            {t("admin.generalManagement.certificateHistoryView") ||
              "증명서 발급 이력 조회"}
          </h3>
        </div>
      </div>
      {tableConfig && rows.length > 0 ? (
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <DynamicTable
            tableConfig={tableConfig}
            dataStructure="flat"
            tableStyle="spreadSheet"
            pagination={true}
            pageSize={50}
            initialPage={1}
            sortable={true}
            initialSortField="issue_date"
            initialSortDirection="desc"
            searchable={true}
            searchPlaceholder={
              t("admin.certificate.searchPlaceholder") || "유형, 대상자"
            }
            searchFields={["certificate_type", "subject_name"]}
            exportable={true}
            exportFileName={"certificate_management"}
            exportButtonLabel="Excel"
            filterable={true}
            filterableColumns={[
              "certificate_type",
              "subject_name",
              "subject_username",
              "issuer_name",
              "issuer_username",
              "purpose",
              "status",
            ]}
            rowNumber={true}
          />
        </div>
      ) : (
        <div className="text-center mt-4">
          <p className="text-muted">
            {t("admin.certificate.loading") || "데이터를 불러오는 중..."}
          </p>
        </div>
      )}
      {/* Certificate Info Modal */}
      {isModalOpen && (
        <CertificateInfoModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          certificateData={selectedCertificate}
        />
      )}
    </>
  );
}
